export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    devices: 'Devices',
    groups: 'Groups',
    users: 'Users',
    download: 'Download',
    logs: 'Audit Logs',
    logout: 'Logout',

    // Dashboard
    totalDevices: 'Total Devices',
    online: 'Online',
    blocked: 'Blocked',
    recentDevices: 'Recent Devices',
    noDevices: 'No devices yet',
    noDevicesDesc: 'Install the agent on a device to see it here',

    // Devices
    refresh: 'Refresh',
    block: 'Block',
    unblock: 'Unblock',
    shutdown: 'Shutdown',
    uninstallPassword: 'Uninstall Password',
    noGroup: 'No group',
    lastSeen: 'Last seen',
    neverConnected: 'Never connected',
    blockDevice: 'Block device?',
    unblockDevice: 'Unblock device?',
    shutdownDevice: 'Shutdown device?',
    blockDeviceDesc: 'Device will be locked. User will not be able to access data.',
    unblockDeviceDesc: 'A recovery code will be generated and sent to the user.',
    shutdownDeviceDesc: 'Device will be shut down when it connects to the internet.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    executing: 'Executing...',
    recoveryCode: 'Recovery Code',
    recoveryCodeDesc: 'Send this code to the device user:',
    close: 'Close',
    uninstallPasswordTitle: 'Agent Uninstall Password',
    uninstallPasswordDesc: 'This password is valid for the current hour:',
    validUntil: 'Valid until',
    copy: 'Copy',
    copied: 'Copied!',

    // Groups
    newGroup: 'New Group',
    noGroups: 'No groups yet',
    name: 'Name',
    description: 'Description',
    create: 'Create',
    lockAll: 'Lock All',
    lockAllDesc: 'All devices in this group will be locked.',
    lock: 'Lock',

    // Users
    invite: 'Invite',
    role: 'Role',
    status: 'Status',
    active: 'Active',
    deactivated: 'Deactivated',
    lastLogin: 'Last Login',
    never: 'Never',
    actions: 'Actions',
    deactivate: 'Deactivate',
    activate: 'Activate',
    inviteUser: 'Invite User',
    inviteCreated: 'Invitation Created',
    inviteToken: 'Send this token to the user:',
    superadmin: 'Super Admin',
    admin: 'Admin',
    operator: 'Operator',
    viewer: 'Viewer',

    // Download
    downloadAgents: 'Download Agents',
    downloadDesc: 'Install the agent on every device you want to protect',
    downloadAgent: 'Download Agent',
    installScript: 'Install Script',
    orgToken: 'Organization Token',
    orgTokenDesc: 'Already embedded in the downloaded agent file.',

    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    yourName: 'Your Name',
    orgName: 'Organization Name',
    loginError: 'Login failed',
    registerError: 'Registration failed',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    loginBtn: 'Sign In',
    registerBtn: 'Register',

    // Audit
    action: 'Action',
    user: 'User',
    device: 'Device',
    ipAddress: 'IP Address',
    time: 'Time',
    noLogs: 'No logs yet',
    blockDeviceLog: 'Device Lock',
    unblockDeviceLog: 'Device Unlock',
    shutdownDeviceLog: 'Device Shutdown',
    blockGroupLog: 'Group Lock',
  },
  uk: {
    // Navigation
    dashboard: 'Дашборд',
    devices: 'Пристрої',
    groups: 'Групи',
    users: 'Користувачі',
    download: 'Завантаження',
    logs: 'Логи дій',
    logout: 'Вийти',

    // Dashboard
    totalDevices: 'Всього пристроїв',
    online: 'Онлайн',
    blocked: 'Заблоковано',
    recentDevices: 'Останні пристрої',
    noDevices: 'Пристроїв ще немає',
    noDevicesDesc: 'Встановіть агент на пристрій щоб він з\'явився тут',

    // Devices
    refresh: 'Оновити',
    block: 'Заблокувати',
    unblock: 'Розблокувати',
    shutdown: 'Вимкнути',
    uninstallPassword: 'Пароль видалення',
    noGroup: 'Без групи',
    lastSeen: 'Останній зв\'язок',
    neverConnected: 'Ніколи не підключався',
    blockDevice: 'Заблокувати пристрій?',
    unblockDevice: 'Розблокувати пристрій?',
    shutdownDevice: 'Вимкнути пристрій?',
    blockDeviceDesc: 'Пристрій буде заблокований. Користувач не зможе отримати доступ до даних.',
    unblockDeviceDesc: 'Буде згенерований код відновлення і відправлений користувачу.',
    shutdownDeviceDesc: 'Пристрій буде вимкнений при наступному підключенні до інтернету.',
    confirm: 'Підтвердити',
    cancel: 'Скасувати',
    executing: 'Виконується...',
    recoveryCode: 'Код відновлення',
    recoveryCodeDesc: 'Відправте цей код користувачу пристрою:',
    close: 'Закрити',
    uninstallPasswordTitle: 'Пароль видалення агента',
    uninstallPasswordDesc: 'Цей пароль діє до кінця поточної години:',
    validUntil: 'Дійсний до',
    copy: 'Копіювати',
    copied: 'Скопійовано!',

    // Groups
    newGroup: 'Нова група',
    noGroups: 'Груп ще немає',
    name: 'Назва',
    description: 'Опис',
    create: 'Створити',
    lockAll: 'Заблокувати всіх',
    lockAllDesc: 'Всі пристрої в цій групі будуть заблоковані.',
    lock: 'Заблокувати',

    // Users
    invite: 'Запросити',
    role: 'Роль',
    status: 'Статус',
    active: 'Активний',
    deactivated: 'Деактивований',
    lastLogin: 'Останній вхід',
    never: 'Ніколи',
    actions: 'Дії',
    deactivate: 'Деактивувати',
    activate: 'Активувати',
    inviteUser: 'Запросити користувача',
    inviteCreated: 'Запрошення створено',
    inviteToken: 'Відправте цей токен користувачу:',
    superadmin: 'Суперадмін',
    admin: 'Адмін',
    operator: 'Оператор',
    viewer: 'Спостерігач',

    // Download
    downloadAgents: 'Завантаження агентів',
    downloadDesc: 'Встановіть агент на кожен пристрій який потрібно захистити',
    downloadAgent: 'Завантажити агент',
    installScript: 'Скрипт встановлення',
    orgToken: 'Токен організації',
    orgTokenDesc: 'Вже вбудований в завантажений файл агента.',

    // Auth
    login: 'Вхід',
    register: 'Реєстрація',
    email: 'Email',
    password: 'Пароль',
    yourName: 'Ваше ім\'я',
    orgName: 'Назва організації',
    loginError: 'Помилка входу',
    registerError: 'Помилка реєстрації',
    noAccount: 'Немає акаунту?',
    haveAccount: 'Вже є акаунт?',
    loginBtn: 'Увійти',
    registerBtn: 'Зареєструватись',

    // Audit
    action: 'Дія',
    user: 'Користувач',
    device: 'Пристрій',
    ipAddress: 'IP адреса',
    time: 'Час',
    noLogs: 'Логів ще немає',
    blockDeviceLog: 'Блокування пристрою',
    unblockDeviceLog: 'Розблокування пристрою',
    shutdownDeviceLog: 'Вимкнення пристрою',
    blockGroupLog: 'Блокування групи',
  }
};

export type Language = 'en' | 'uk';
export type TranslationKey = keyof typeof translations.en;
